export default {
    SetActive(context, val){
        context.commit('Active', val);  
    },

}
